<template>
  <div class="yhgl">
    <div class="thrkBody">
      <div class="bodyHeader">
        <el-form
          ref="search"
          :inline="true"
          :model="searchForm"
          style="width: 100%; padding: 10px 20px; margin-bottom: 20px"
          label-position="left"
        >
          <el-form-item label="登录账号" prop="loginName">
            <el-input
              v-model="searchForm.loginName"
              placeholder="手机号"
            />
          </el-form-item>
          <el-form-item label="身份类型" prop="identityType">
            <el-select v-model="searchForm.identityType" clearable placeholder="全部" style="width: 130px">
              <el-option
                v-for="item in identityTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="处理场景" prop="scene">
            <el-select v-model="searchForm.scene" clearable placeholder="全部" style="width: 160px">
              <el-option
                v-for="item in sceneOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="结果" prop="status">
            <el-select v-model="searchForm.status" clearable placeholder="全部" style="width: 140px">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="登录IP" prop="loginIp">
            <el-input v-model="searchForm.loginIp" placeholder="登录IP" />
          </el-form-item>
          <el-form-item label="登录时间" prop="startTime">
            <el-date-picker
              v-model="searchForm.startTime"
              type="datetime"
              style="width: 180px"
              placeholder="开始时间"
            />
            -
          </el-form-item>
          <el-form-item prop="endTime">
            <el-date-picker
              v-model="searchForm.endTime"
              type="datetime"
              style="width: 180px"
              placeholder="结束时间"
            />
          </el-form-item>
          <el-form-item>
            <div style="display: flex; margin-left: 20px">
              <el-button
                type="primary"
                icon="el-icon-search"
                round
                size="small"
                @click="searchHandle"
              >搜索</el-button>
              <el-button
                icon="el-icon-refresh-left"
                style="width: 90px; height: 39px"
                round
                size="small"
                @click="reset"
              >重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="thrkRight">
        <div class="bodyTable">
          <div class="thrkLeft2">
            <el-table
              border
              :data="tableData"
              :header-cell-style="{
                'text-align': 'center',
                background: '#f4f4f4',
              }"
              :cell-style="{ 'text-align': 'center' }"
              style="width: 100%"
            >
              <el-table-column
                prop="loginTime"
                label="登录时间"
                width="160"
                align="center"
              />
              <el-table-column
                prop="identityType"
                label="身份类型"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  {{ identityTypeMap[scope.row.identityType] || scope.row.identityType || '-' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="scene"
                label="处理场景"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  {{ sceneMap[scope.row.scene] || scope.row.scene || '-' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="结果"
                width="110"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status" :type="statusTagType(scope.row.status)" size="small">
                    {{ statusMap[scope.row.status] || scope.row.status }}
                  </el-tag>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="loginName"
                label="登录账号"
                width="130"
                align="center"
              />
              <el-table-column
                prop="userName"
                label="姓名"
                width="100"
                align="center"
              />
              <el-table-column
                prop="phonenumber"
                label="手机号"
                width="130"
                align="center"
              />
              <el-table-column
                prop="corpName"
                label="单位名称"
                min-width="180"
                align="center"
              />
              <el-table-column
                prop="certificateSno"
                label="统一社会信用代码"
                width="190"
                align="center"
              />
              <el-table-column
                prop="loginIp"
                label="登录IP"
                width="140"
                align="center"
              />
              <el-table-column
                prop="browser"
                label="浏览器"
                width="110"
                align="center"
              />
              <el-table-column
                prop="version"
                label="浏览器版本"
                width="110"
                align="center"
              />
              <el-table-column
                prop="os"
                label="系统类型"
                width="110"
                align="center"
              />
              <el-table-column
                prop="isMobile"
                label="是否手机"
                width="90"
                align="center"
              >
                <template slot-scope="scope">{{ scope.row.isMobile ? '是' : '否' }}</template>
              </el-table-column>
              <el-table-column
                prop="msg"
                label="结果说明"
                min-width="200"
                align="center"
              />
            </el-table>

            <el-pagination
              background
              layout="prev,pager,next,jumper,total,sizes"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGabLoginLogs } from '@/assets/js/system'
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      total: 0,
      tableData: [],
      searchForm: {
        loginName: '',
        identityType: '',
        scene: '',
        status: '',
        loginIp: '',
        startTime: '',
        endTime: ''
      },
      identityTypeMap: {
        NA: '自然人',
        CP: '法人',
        PY: '经办人'
      },
      identityTypeOptions: [
        { label: '自然人', value: 'NA' },
        { label: '法人', value: 'CP' },
        { label: '经办人', value: 'PY' }
      ],
      sceneMap: {
        AUTH: '授权校验',
        NATURAL_LOGIN: '自然人登录',
        NATURAL_REGISTER: '自然人注册',
        CORP_LOGIN: '法人/经办人登录',
        DRAFT_FILL: '带入企业信息登录',
        CORP_JOIN: '加入企业',
        CORP_REGISTER: '企业注册',
        REGISTER: '补全注册',
        REGISTER_JOIN: '注册并加入企业'
      },
      sceneOptions: [
        { label: '授权校验', value: 'AUTH' },
        { label: '自然人登录', value: 'NATURAL_LOGIN' },
        { label: '自然人注册', value: 'NATURAL_REGISTER' },
        { label: '法人/经办人登录', value: 'CORP_LOGIN' },
        { label: '带入企业信息登录', value: 'DRAFT_FILL' },
        { label: '加入企业', value: 'CORP_JOIN' },
        { label: '企业注册', value: 'CORP_REGISTER' },
        { label: '补全注册', value: 'REGISTER' },
        { label: '注册并加入企业', value: 'REGISTER_JOIN' }
      ],
      statusMap: {
        SUCCESS: '成功',
        NEED_REGISTER: '待补全注册',
        FAIL: '失败'
      },
      statusOptions: [
        { label: '成功', value: 'SUCCESS' },
        { label: '待补全注册', value: 'NEED_REGISTER' },
        { label: '失败', value: 'FAIL' }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    reset() {
      this.$refs['search'].resetFields()
      this.searchHandle()
    },
    buildParam() {
      const param = {}
      if (this.searchForm.loginName) {
        param.loginName = this.searchForm.loginName.trim()
      }
      if (this.searchForm.identityType) {
        param.identityType = this.searchForm.identityType
      }
      if (this.searchForm.scene) {
        param.scene = this.searchForm.scene
      }
      if (this.searchForm.status) {
        param.status = this.searchForm.status
      }
      if (this.searchForm.loginIp) {
        param.loginIp = this.searchForm.loginIp.trim()
      }
      if (this.searchForm.startTime) {
        param.startTime = this.searchForm.startTime
      }
      if (this.searchForm.endTime) {
        param.endTime = this.searchForm.endTime
      }
      return param
    },
    loadData() {
      getGabLoginLogs({
        page: this.currentPage,
        size: this.pagesize,
        param: this.buildParam()
      }).then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    searchHandle() {
      this.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.loadData()
    },
    statusTagType(status) {
      if (status === 'SUCCESS') {
        return 'success'
      }
      if (status === 'NEED_REGISTER') {
        return 'warning'
      }
      if (status === 'FAIL') {
        return 'danger'
      }
      return 'info'
    }
  }
}
</script>
<style scoped lang='less'>
.yhgl {
  .thrkBody {
    margin: 0 auto;
    .bodyHeader {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      margin-bottom: 11px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      padding: 30px 0 0 0;
      border-radius: 5px;
      .el-form-item {
        margin-right: 20px;
        .el-form-item__content {
          display: flex;
        }
      }

      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-color: #4170ff;
        width: 90px;
        height: 39px;
      }
    }
    .thrkRight {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 57px;
      .bodyTable {
        width: calc(100% - 40px);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .thrkLeft2 {
          width: 100%;
          .el-button--primary {
            color: #fff;
            background: #4170ff;
            border-radius: 3px;
            border-color: #4170ff;
          }
        }
      }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;
        border: 1px solid #ebeef5;
        border-top: 0;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
